import { useEffect } from 'react'
import { Routes, Route, Navigate, useParams, Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  supportedLanguages,
  defaultLanguage,
  type SupportedLanguage,
} from '@/i18n'
import { Header, Footer } from '@/components/layout'
import Home from '@/pages/Home'
import About from '@/pages/About'
import Company from '@/pages/Company'
import Services from '@/pages/Services'
import ServiceDetail from '@/pages/ServiceDetail'
import History from '@/pages/History'
import Certifications from '@/pages/Certifications'
import Contact from '@/pages/Contact'
import Privacy from '@/pages/Privacy'

function LanguageWrapper() {
  const { lang } = useParams<{ lang: string }>()
  const { i18n } = useTranslation()

  useEffect(() => {
    if (lang && supportedLanguages.includes(lang as SupportedLanguage)) {
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang)
      }
    }
  }, [lang, i18n])

  // Redirect invalid language to default
  if (!lang || !supportedLanguages.includes(lang as SupportedLanguage)) {
    return <Navigate to={`/${defaultLanguage}`} replace />
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
    </div>
  )
}

export function LanguageRouter() {
  return (
    <Routes>
      {/* Redirect root to default language */}
      <Route path="/" element={<Navigate to={`/${defaultLanguage}`} replace />} />

      {/* Language-prefixed routes */}
      <Route path="/:lang" element={<LanguageWrapper />}>
        <Route index element={<Home />} />
        <Route path="azienda" element={<Company />} />
        <Route path="company" element={<Company />} />
        <Route path="chi-siamo" element={<About />} />
        <Route path="about-us" element={<About />} />
        <Route path="servizi" element={<Services />} />
        <Route path="services" element={<Services />} />
        <Route path="servizi/:serviceId" element={<ServiceDetail />} />
        <Route path="services/:serviceId" element={<ServiceDetail />} />
        <Route path="storia" element={<History />} />
        <Route path="history" element={<History />} />
        <Route path="certificazioni" element={<Certifications />} />
        <Route path="certifications" element={<Certifications />} />
        <Route path="contatti" element={<Contact />} />
        <Route path="contacts" element={<Contact />} />
        <Route path="privacy" element={<Privacy />} />
      </Route>
    </Routes>
  )
}
